// assets/shopping-guide.js
// ショッピングガイド タブ切り替え用

(function () {
  var navButtons = document.querySelectorAll(".shopping-guide .guide-nav__item");
  var sections = document.querySelectorAll(".shopping-guide .guide-section");

  if (!navButtons.length || !sections.length) return;

  function activateSection(targetId) {
    sections.forEach(function (sec) {
      sec.classList.toggle("is-active", sec.id === targetId);
    });

    navButtons.forEach(function (btn) {
      var isActive = btn.getAttribute("data-target") === targetId;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-selected", isActive ? "true" : "false");
    });
  }

  // クリックでタブ切り替え
  navButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var targetId = btn.getAttribute("data-target");
      if (!targetId) return;

      activateSection(targetId);

      // URL ハッシュを更新したい場合は下を有効化
      // history.replaceState(null, "", "#" + targetId);
    });
  });

  // URL ハッシュに応じて初期表示を切り替え
  document.addEventListener("DOMContentLoaded", function () {
    var hash = window.location.hash.replace("#", "");
    if (!hash) return;
    var targetSection = document.getElementById(hash);
    if (targetSection) {
      activateSection(hash);
    }
  });
})();